<template>
  <router-view></router-view>
</template>
<script>
import {mapState} from "vuex";


export default {
  name: 'App',
  data(){
    return {
    }
  },
  methods:{
  },
  computed:{
    ...mapState([
      'currentPage'
    ]),
  },
  watch:{
    currentPage:{
      immediate:true,
      handler(){
        this.$router.push(this.currentPage);//跳转到变化后的页面
      }
    }
  },
}

</script>

<style>


</style>
